module.exports = __webpack_public_path__ + "img/arrowRight.e673e62c.svg";